import {Pipe, type PipeTransform} from '@angular/core'

@Pipe({
  name: 'decodeUri',
})
export class DecodeUriPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return decodeURIComponent(value)
  }
}
